import React from "react";
import s from "./Card.module.scss";
import { Avatar } from "../../../../../../../../global components/Icons/Avatar";
type PropType = {
  userType: string;
  onClick: () => void;
};
function Card({ userType, onClick }: PropType) {
  return (
    <div className={s.wrapper} onClick={onClick}>
      <div className={s.iconWrapper}>
        <Avatar className={s.icon} />
      </div>
      <p className={s.label}>{userType}</p>
    </div>
  );
}

export default Card;
